import React from 'react';
import './getquote.css';
import ContactRequest from '../../components/contact_request/ContactRequest';

const GetQuote = () => {
    return (
        <div className="get-quote-page">
            <div className="get-quote-container">
                <h1>Request a Quote</h1>
                <p>Fill out the form below to request a quote for our LiDAR consulting services.</p>
                <ContactRequest />
            </div>
        </div>
    );
};

export default GetQuote;